import { FlowVersion } from "src/api/flowTypes";
import { PALETTE } from "src/design-system/utils/colorPalette";

export type VersionColors = Record<string, string>;

export const getVersionsColors = (versions: FlowVersion[]) => {
  return versions
    .sort(
      (a, b) =>
        new Date(a.created_at).valueOf() - new Date(b.created_at).valueOf(),
    )
    .reduce((acc, v, i) => {
      acc[v.id] = PALETTE[i % PALETTE.length];
      return acc;
    }, {} as VersionColors);
};
